export default __webpack_public_path__ + "static/media/IMG_0379-2.fd4514f8.jpg";